
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.501 22.5a2.252 2.252 0 01-2.25-2.25v-6.573l-.134-.113c-1.8-1.514-3.661-3.081-3.615-5.006V4.37L.163 2.683A.751.751 0 01.75 1.467c.23 0 .445.103.588.284l1.5 1.892a.75.75 0 01.163.466v4.467c-.023.977.957 2.006 2.25 3.132V8.451l-.556-.569a.751.751 0 011.074-1.048l.711.728c.042.035.08.074.113.115l.945.968a.468.468 0 00.803-.319.466.466 0 00-.133-.333l-2.75-2.806a.745.745 0 01-.213-.524V3.265a5.502 5.502 0 00-.851-2.097A.751.751 0 015.64.332a7.003 7.003 0 011.095 2.742c.007.043.01.084.01.126v1.157l2.537 2.588c.368.378.566.875.559 1.401a1.959 1.959 0 01-.594 1.384c-.369.36-.857.558-1.373.558-.408 0-.796-.122-1.123-.35V20.25c0 .414.336.75.75.75h6.75a.75.75 0 010 1.5h-6.75zM18.989 23.996a.747.747 0 01-.623-.332 6.985 6.985 0 01-1.094-2.737.747.747 0 01-.011-.126v-1.155l-2.54-2.589a1.971 1.971 0 01.034-2.785 1.915 1.915 0 011.409-.558 1.95 1.95 0 011.375.594l.463.473V5.25a.75.75 0 00-.75-.75h-7.5A.75.75 0 019.751 3h7.5a2.252 2.252 0 012.25 2.25v5.708c1.62 1.385 3.041 2.777 3 4.485v4.187l1.338 1.687a.747.747 0 01-.588 1.216.748.748 0 01-.588-.284l-1.5-1.892a.756.756 0 01-.162-.466v-4.466c.019-.802-.675-1.661-1.5-2.452v3.648a.747.747 0 01-.75.75.755.755 0 01-.537-.226l-1.75-1.79a.462.462 0 00-.331-.143.468.468 0 00-.341.795l2.753 2.806a.748.748 0 01.215.525v1.396c.137.753.423 1.457.851 2.094a.748.748 0 01-.622 1.168z"}})])
          )
        }
      }
    